import { httpCodes } from '@/modules/shared/constants/httpCodes'

import BaseHTTPError from './BaseHTTPError'

export default class InternalServerError<Data> extends BaseHTTPError<Data> {
  constructor(info: { message: string; action: string; data?: Data }) {
    super({
      name: InternalServerError.name,
      httpCode: httpCodes.INTERNAL_ERROR,
      message: info.message,
      action: info.action,
      data: info?.data
    })
  }
}
